import React, { PropTypes } from 'react';
import styles from './styles.scss';

class ComparisonPanel extends React.Component {
  render() {
    const { currentMode, handleModeChange } = this.context;
    return(
      <div className="slds-p-around_medium">
        <div className="slds-form-element">
          <label className="slds-checkbox_toggle slds-grid">
            <span className="slds-form-element__label slds-m-bottom_none">Before / After</span>
            <input
              onChange={e => handleModeChange(e.target.checked ? "comparison" : "animating")}
              type="checkbox"
              checked={currentMode === "comparison"}
              name="comparison-toggle"
              value="comparison-toggle"
              aria-describedby="comparison-toggle"
            />
            <span id="comparison-toggle" className="slds-checkbox_faux_container" aria-live="assertive">
              <span className="slds-checkbox_faux"></span>
              <span className="slds-checkbox_on">Enabled</span>
              <span className="slds-checkbox_off">Disabled</span>
            </span>
          </label>
        </div>
      </div>
    );
  }
}

ComparisonPanel.contextTypes = {
  currentMode: PropTypes.string,
  handleModeChange: PropTypes.func
};

export default ComparisonPanel;



// WEBPACK FOOTER //
// ./src/components/ComparisonPanel/index.js